module.exports = __webpack_public_path__ + "Assets/Images/background-pattern-1.png";